import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { LogistikRoutes } from '@chancenlogistik/client/routes';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement logistik-page-order-success
 */
@customElement('logistik-page-order-success')
export class LogistikPageOrderSuccess extends ChemistryLitElement {
  override render() {
    return html`
      <logistik-component-base-page-layout>
        <logistik-component-base-header
          pageTitle="Bestellung erfolgreich"
          backRoute=${LogistikRoutes.landing}
        ></logistik-component-base-header>
        <cr-flex ${css({ height: '100%' })} center crossaxis-center space="lg">
          <cr-icon ${css({ fontSize: this.spacing.xl })}> celebration </cr-icon>
          <cr-text size="large" weight="bold">Bestellung erfolgreich</cr-text>
        </cr-flex>
      </logistik-component-base-page-layout>
    `;
  }
}
